/* Aesthetics Brothers: pedido mínimo + escala de mayoreo.
   Regla (v2, ropa desde 1 pieza):
   - La ropa de las marcas en ROPA_VENDORS se puede comprar desde 1 pieza.
   - Si el carrito trae suplementos (todo lo que no es ropa), deben ser al menos MIN piezas.
   - Carritos mixtos permitidos: ej. 3 suplementos + 1 prenda.
   1) Bloquea el paso al checkout cuando la regla no se cumple.
   2) Muestra una etiqueta fija con el estado del carrito y la escala de mayoreo.
   3) En la ficha de suplementos muestra el precio por pieza en cada nivel (no en ropa),
      calculado con el precio de la variante seleccionada (v3, 2026-10-17).
   Para cambiar el mínimo edita MIN; para la escala edita TIERS (debe coincidir con los
   descuentos automáticos de Shopify); para agregar marcas de ropa edita ROPA_VENDORS.
   v4 (2026-11-04): escala por porcentaje (4 piezas 4%, 5 piezas 5% ... 10+ piezas 10%),
   igual a los descuentos automáticos "Mayoreo N piezas: N% de descuento" del 3 nov 2026.
   Antes era $15/$30/$40 menos por pieza desde 10/20/40 piezas.
   v5 AB-TOPE-5 (2026-11-04): tope de 5% en productos de más de $1,000.
   - Un producto lleva tope cuando CUALQUIERA de sus sabores/tallas cuesta más de $1,000.00
     (price_max > TOPE_CENTS). Exactamente $1,000 no lleva tope. El tope es del producto:
     también sus sabores más baratos llevan máximo 5%.
   - 4% (4+ piezas) y 5% (5+ piezas) aplican a todos los suplementos y cuentan todas las piezas.
   - 6% a 10% (6 a 10+ piezas) aplican solo a productos sin tope y cuentan solo esas piezas.
   - Shopify aplica un solo descuento por renglón, el mejor.
   - Tabla de la ficha: con tope muestra 3 piezas / 4 piezas -4% / 5 o más -5% (TIERS_TOPE).
     El tope lo manda product-template.liquid en window.abTope5[handle]; si falta, usa price_max.
   - Etiqueta del carrito: separa piezas con tope y sin tope (precio del renglón > $1,000 o
     price_max del producto, que se consulta una vez por producto en /products/<handle>.js).
   Para cambiar el tope edita TOPE_CENTS y TIERS_TOPE (deben coincidir con los descuentos de Shopify).
   Para desactivar todo, quita la línea que carga este archivo en layout/theme.liquid. */
(function(){
  var MIN = 3;
  var ROPA_VENDORS = ['youngla'];
  var TIERS = [
    {qty: 4, pct: 4},
    {qty: 5, pct: 5},
    {qty: 6, pct: 6},
    {qty: 7, pct: 7},
    {qty: 8, pct: 8},
    {qty: 9, pct: 9},
    {qty: 10, pct: 10}
  ];
  /* AB-TOPE-5 (2026-11-04): productos de más de $1,000 llevan máximo 5% */
  var TOPE_CENTS = 100000;
  var TOPE_PCT = 5;
  var TIERS_TOPE = [
    {qty: 4, pct: 4},
    {qty: 5, pct: 5}
  ];
  /* precio por pieza con el % de descuento, redondeado hacia arriba al centavo */
  function conDescuento(cents, pct){ return Math.ceil(Math.round(cents) * (100 - pct) / 100); }
  var bypass = false;

  function isRopa(vendor){
    var v = (vendor || '').toString().trim().toLowerCase();
    return ROPA_VENDORS.indexOf(v) > -1;
  }

  /* Devuelve {total, supl, ropa, renglones} o null si no se pudo leer el carrito.
     AB-TOPE-5: renglones = suplementos del carrito {handle, q, precio} para separar los que llevan tope. */
  function fetchCounts(){
    return fetch('/cart.js', {credentials: 'same-origin', cache: 'no-store'})
      .then(function(r){ return r.json(); })
      .then(function(c){
        if (!c || !c.items) return null;
        var supl = 0, ropa = 0, renglones = [];
        for (var i = 0; i < c.items.length; i++){
          var it = c.items[i];
          var q = it.quantity || 0;
          if (isRopa(it.vendor)) ropa += q;
          else {
            supl += q;
            renglones.push({handle: it.handle, q: q, precio: Number(it.original_price != null ? it.original_price : it.price) || 0});
          }
        }
        return {total: supl + ropa, supl: supl, ropa: ropa, renglones: renglones};
      })
      .catch(function(){ return null; });
  }

  /* ---------- AB-TOPE-5 (2026-11-04): qué productos llevan tope de 5% ----------
     Un renglón lleva tope si su precio pasa de $1,000 o si algún otro sabor del mismo producto
     pasa de $1,000 (price_max). price_max se pide una vez por producto y se guarda 30 min. */
  var MAX_KEY = 'ab-tope5-max-v1', MAX_MS = 30 * 60 * 1000;
  var maxes = {}, pidiendo = {};
  try { maxes = JSON.parse(window.sessionStorage.getItem(MAX_KEY) || '{}') || {}; } catch (e) { maxes = {}; }
  function guardarMaxes(){ try { window.sessionStorage.setItem(MAX_KEY, JSON.stringify(maxes)); } catch (e) {} }

  function precioMaxProducto(handle){
    if (!handle) return Promise.resolve(null);
    var m = window.abTope5;
    if (m && typeof m[handle] === 'boolean') return Promise.resolve(m[handle] ? TOPE_CENTS + 1 : 0);
    var c = maxes[handle];
    if (c && c.t && Date.now() - c.t < MAX_MS) return Promise.resolve(c.m);
    if (pidiendo[handle]) return pidiendo[handle];
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    pidiendo[handle] = fetch(base + 'products/' + encodeURIComponent(handle) + '.js', {credentials: 'same-origin'})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p) return null;
        var mx = Number(p.price_max) || 0;
        (p.variants || []).forEach(function(v){ if (v && Number(v.price) > mx) mx = Number(v.price); });
        maxes[handle] = {t: Date.now(), m: mx};
        guardarMaxes();
        return mx;
      })
      .catch(function(){ return null; })
      .then(function(mx){ delete pidiendo[handle]; return mx; });
    return pidiendo[handle];
  }

  /* Agrega a c: tope = piezas con tope (máx. 5%), libres = piezas sin tope (hasta 10%).
     Si no se pudo consultar el producto, decide solo con el precio del renglón. */
  function contarTope(c){
    if (!c || !c.renglones || !c.renglones.length){
      if (c){ c.tope = 0; c.libres = c.supl; }
      return Promise.resolve(c);
    }
    return Promise.all(c.renglones.map(function(r){
      if (r.precio > TOPE_CENTS) return Promise.resolve(true);
      return precioMaxProducto(r.handle).then(function(mx){ return mx != null && mx > TOPE_CENTS; });
    })).then(function(topes){
      var tope = 0;
      for (var i = 0; i < topes.length; i++){ if (topes[i]) tope += c.renglones[i].q; }
      c.tope = tope;
      c.libres = c.supl - tope;
      return c;
    });
  }

  function cumple(c){
    if (!c) return true; /* si no se pudo leer, no bloqueamos */
    if (c.supl === 0) return c.ropa >= 1;
    return c.supl >= MIN;
  }

  function plural(n, s, p){ return n === 1 ? s : p; }

  function money(cents){
    var n = Math.round(cents) / 100;
    var dec = (Math.round(cents) % 100 === 0) ? 0 : 2;
    return '$' + n.toLocaleString('es-MX', {minimumFractionDigits: dec, maximumFractionDigits: 2});
  }

  /* ---------- Etiqueta de escala (carrito) ---------- */
  function pillText(c){
    if (c.supl > 0 && c.supl < MIN){
      var f = MIN - c.supl;
      return 'Suplementos: llevas ' + c.supl + ' · mínimo ' + MIN + ' (agrega ' + f + ' más)';
    }
    if (c.supl === 0){
      return 'Ropa: llevas ' + c.ropa + plural(c.ropa, ' pieza', ' piezas') + ' · se puede pedir desde 1';
    }
    var n = c.supl; /* YoungLA no está en la colección de mayoreo */
    if (c.tope > 0) return pillTextTope(c);
    var current = null, next = null;
    for (var i = 0; i < TIERS.length; i++){
      if (n >= TIERS[i].qty) current = TIERS[i];
      else { next = TIERS[i]; break; }
    }
    var txt = current
      ? 'Llevas ' + n + ' suplementos · tienes ' + current.pct + '% de descuento'
      : 'Llevas ' + n + plural(n, ' suplemento', ' suplementos');
    if (next){
      txt += ' · agrega ' + (next.qty - n) + ' más y ' + (current ? 'sube a ' : 'obtén ') + next.pct + '%';
    } else {
      txt += ' (el máximo)';
    }
    return txt;
  }

  /* AB-TOPE-5 (2026-11-04): carrito con productos de más de $1,000.
     n = todos los suplementos, u = piezas sin tope. Con tope: 4% desde 4 piezas, 5% desde 5 (cuentan todas).
     Sin tope: además 6% a 10% según cuántas piezas sin tope haya (cuentan solo esas). */
  function pillTextTope(c){
    var n = c.supl, u = Math.max(0, c.libres || 0);
    var tieneMax = n >= TIERS_TOPE[TIERS_TOPE.length - 1].qty; /* ya tiene el 5% */
    var txt = 'Llevas ' + n + plural(n, ' suplemento', ' suplementos');
    if (!tieneMax){
      var sig = null, act = null;
      for (var i = 0; i < TIERS_TOPE.length; i++){
        if (n >= TIERS_TOPE[i].qty) act = TIERS_TOPE[i]; else { sig = TIERS_TOPE[i]; break; }
      }
      if (act) txt += ' · tienes ' + act.pct + '% de descuento';
      if (sig) txt += ' · agrega ' + (sig.qty - n) + ' más y ' + (act ? 'sube a ' : 'obtén ') + sig.pct + '%';
      return txt + ' · los de más de $1,000 llevan hasta ' + TOPE_PCT + '%';
    }
    var maxTier = TIERS[TIERS.length - 1];
    var pctLibres = 0; /* % de las piezas sin tope por su propia cuenta (6 a 10) */
    for (var j = 0; j < TIERS.length; j++){ if (u >= TIERS[j].qty && TIERS[j].pct > TOPE_PCT) pctLibres = TIERS[j].pct; }
    if (pctLibres > TOPE_PCT){
      txt += ' · tienes ' + pctLibres + '% en los de hasta $1,000 y ' + TOPE_PCT + '% en los de más de $1,000';
    } else {
      txt += ' · tienes ' + TOPE_PCT + '% de descuento · los de más de $1,000 llevan hasta ' + TOPE_PCT + '%';
    }
    if (u > 0 && u < maxTier.qty){
      var meta = null;
      for (var k = 0; k < TIERS.length; k++){ if (TIERS[k].pct > Math.max(TOPE_PCT, pctLibres) && TIERS[k].qty > u){ meta = TIERS[k]; break; } }
      if (meta) txt += ' · agrega ' + (meta.qty - u) + ' de hasta $1,000 y suben a ' + meta.pct + '%';
    }
    return txt;
  }

  function ensurePill(){
    var pill = document.getElementById('ab-escala');
    if (!pill){
      pill = document.createElement('a');
      pill.id = 'ab-escala';
      pill.href = '/collections/suplementos';
      pill.setAttribute('aria-label', 'Ver suplementos');
      pill.style.cssText = 'position:fixed;left:12px;bottom:12px;z-index:999998;max-width:72%;background:#fff;color:#111;border:1px solid rgba(0,0,0,.12);box-shadow:0 6px 18px rgba(0,0,0,.14);border-radius:12px;padding:10px 14px;font-weight:700;font-size:13px;line-height:1.3;text-decoration:none;display:none;';
      document.body.appendChild(pill);
    }
    return pill;
  }

  function refreshPill(){
    fetchCounts().then(contarTope).then(function(c){ /* AB-TOPE-5: separa piezas con tope */
      if (!document.body) return;
      var pill = ensurePill();
      if (!c || c.total < 1){ pill.style.display = 'none'; return; }
      pill.textContent = pillText(c);
      pill.style.display = 'block';
    });
  }

  function refreshSoon(delay){
    clearTimeout(refreshSoon._t);
    refreshSoon._t = setTimeout(refreshPill, delay || 400);
  }

  /* ---------- Tabla de precio por pieza (solo suplementos) ----------
     v3: usa el precio de la variante (sabor/tamaño) seleccionada y se
     actualiza al cambiarla. Antes usaba p.price, que en Shopify es el precio
     MÁS BAJO de todas las variantes, y mostraba ese precio para todos los sabores. */
  var tablaProd = null, tablaVarId = null;

  /* AB-TOPE-5 (2026-11-04): ¿el producto lleva tope de 5%? Primero lo que manda Liquid
     (product-template.liquid escribe window.abTope5[handle]); si no está, usa price_max de /products/<handle>.js. */
  function esTope5(p){
    if (!p) return false;
    var m = window.abTope5;
    if (m && p.handle && typeof m[p.handle] === 'boolean') return m[p.handle];
    var mx = Number(p.price_max) || 0;
    (p.variants || []).forEach(function(v){ if (v && Number(v.price) > mx) mx = Number(v.price); });
    return mx > TOPE_CENTS;
  }

  function variantePorId(id){
    if (!tablaProd || !id) return null;
    for (var i = 0; i < tablaProd.variants.length; i++){
      if (String(tablaProd.variants[i].id) === String(id)) return tablaProd.variants[i];
    }
    return null;
  }

  function varianteActual(){
    var m = location.search.match(/[?&]variant=(\d+)/);
    var v = m && variantePorId(m[1]);
    if (v) return v;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++){
      var inp = forms[i].querySelector('[name="id"]');
      v = inp && variantePorId(inp.value);
      if (v) return v;
    }
    var vs = tablaProd.variants;
    for (var j = 0; j < vs.length; j++){ if (vs[j].available) return vs[j]; }
    return vs[0];
  }

  function dibujarTabla(){
    if (!tablaProd) return;
    var v = varianteActual();
    if (!v || typeof v.price !== 'number') return;
    if (String(v.id) === String(tablaVarId) && document.getElementById('ab-tabla-escala')) return;
    var anchor = document.querySelector('.product-block--price');
    if (!anchor) return;
    tablaVarId = v.id;
    var base = v.price;
    /* AB-TOPE-5 (2026-11-04): productos de más de $1,000 solo llegan a 5% (tope del producto, no del sabor) */
    var tope = esTope5(tablaProd);
    var tiers = tope ? TIERS_TOPE : TIERS;
    var desde = MIN, hastaBase = tiers[0].qty - 1;
    var rows = [{label: (desde === hastaBase ? desde : desde + ' a ' + hastaBase) + ' piezas', pct: 0, price: base, best: false}];
    for (var i = 0; i < tiers.length; i++){
      var precio = conDescuento(base, tiers[i].pct);
      if (precio <= 0) continue;
      var fin = tiers[i + 1] ? tiers[i + 1].qty - 1 : null;
      var etiqueta = fin === null ? tiers[i].qty + ' o más piezas' : (fin === tiers[i].qty ? tiers[i].qty + ' piezas' : tiers[i].qty + ' a ' + fin + ' piezas');
      rows.push({label: etiqueta, pct: tiers[i].pct, price: precio, best: !tiers[i + 1]});
    }
    var box = document.getElementById('ab-tabla-escala');
    if (!box){
      box = document.createElement('div');
      box.id = 'ab-tabla-escala';
      box.style.cssText = 'margin:14px 0;padding:12px 14px;border:1px solid rgba(0,0,0,.12);border-radius:12px;background:#fafafa;font-size:13px;line-height:1.4;max-width:420px;';
      anchor.insertAdjacentElement('afterend', box);
    }
    box.setAttribute('data-ab-tope', tope ? '5' : '10'); /* AB-TOPE-5: lo lee ab-look.js para la pestaña */
    var nombre = (tablaProd.variants.length > 1 && v.title && v.title !== 'Default Title') ? v.title : '';
    var html = '<div style="font-weight:800;margin-bottom:8px;">Precio por pieza según cuántas lleves (Buen Fin)</div>';
    if (nombre) html += '<div style="margin:-4px 0 8px;opacity:.75;font-size:12px;"></div>';
    html += '<table style="width:100%;border-collapse:collapse;margin:0;">';
    for (var j = 0; j < rows.length; j++){
      html += '<tr>' +
        '<td style="padding:5px 0;border:0;border-top:1px solid rgba(0,0,0,.08);' + (rows[j].best ? 'font-weight:800;color:#1e55d0;' : '') + '">' + rows[j].label + '</td>' +
        '<td style="padding:5px 8px;border:0;border-top:1px solid rgba(0,0,0,.08);text-align:center;font-weight:700;color:#1e55d0;white-space:nowrap;">' + (rows[j].pct ? '-' + rows[j].pct + '%' : '') + '</td>' +
        '<td style="padding:5px 0;border:0;border-top:1px solid rgba(0,0,0,.08);text-align:right;font-weight:800;white-space:nowrap;' + (rows[j].best ? 'color:#1e55d0;' : '') + '">' + money(rows[j].price) + ' c/u</td>' +
        '</tr>';
    }
    html += '</table>';
    /* AB-TOPE-5 (2026-11-04): aviso del tope */
    html += '<div style="margin-top:8px;color:#1e55d0;font-size:12px;font-weight:700;">' +
      (tope ? 'En productos de más de $1,000 el descuento máximo es 5%.' : 'Del 6% al 10% cuentan solo productos de hasta $1,000.') + '</div>';
    html += '<div style="margin-top:4px;color:#666;font-size:12px;">Cuenta todos los suplementos de tu carrito, aunque sean productos distintos (la ropa YoungLA no cuenta). El descuento se aplica solo.</div>';
    box.innerHTML = html;
    if (nombre) box.children[1].textContent = 'Opción elegida: ' + nombre;
  }

  function renderTabla(){
    if (location.pathname.indexOf('/products/') === -1) return;
    if (!document.querySelector('.product-block--price')) return;
    var url = location.pathname.replace(/\/$/, '') + '.js';
    fetch(url, {credentials: 'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(p){
        if (!p || !p.variants || !p.variants.length) return;
        if (isRopa(p.vendor)) return;
        tablaProd = p;
        dibujarTabla();
        document.addEventListener('change', function(){ setTimeout(dibujarTabla, 60); }, true);
        document.addEventListener('click', function(){ setTimeout(dibujarTabla, 250); }, true);
        setInterval(dibujarTabla, 700);
      })
      .catch(function(){});
  }

  /* ---------- Bloqueo de checkout ---------- */
  function isCheckoutEl(el){
    if (!el || el.nodeType !== 1) return false;
    var tag = el.tagName;
    if (tag !== 'BUTTON' && tag !== 'A' && tag !== 'INPUT') return false;
    var name = (el.getAttribute('name') || '').toLowerCase();
    var href = (el.getAttribute('href') || '').toLowerCase();
    var cls = (typeof el.className === 'string' ? el.className : '').toLowerCase();
    var id = (el.id || '').toLowerCase();
    if (name === 'checkout') return true;
    if (tag === 'A' && /\/checkout(\/|\?|#|$)/.test(href)) return true;
    if (cls.indexOf('checkout') > -1 || id.indexOf('checkout') > -1) return true;
    return false;
  }

  function showMsg(c){
    var box = document.getElementById('ab-min3-msg');
    if (!box){
      box = document.createElement('div');
      box.id = 'ab-min3-msg';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483647;max-width:92%;background:#111;color:#fff;padding:14px 18px;border-radius:10px;font-weight:600;font-size:15px;line-height:1.35;text-align:center;box-shadow:0 8px 24px rgba(0,0,0,.3);';
      document.body.appendChild(box);
    }
    var falta = MIN - (c ? c.supl : 0);
    box.textContent = 'Los suplementos se envían desde ' + MIN + ' piezas. Agrega ' + falta + plural(falta, ' suplemento', ' suplementos') + ' más. La ropa se puede pedir desde 1 pieza.';
    box.style.display = 'block';
    clearTimeout(showMsg._t);
    showMsg._t = setTimeout(function(){ box.style.display = 'none'; }, 7000);
  }

  document.addEventListener('click', function(e){
    refreshSoon(600);
    if (bypass) return;
    var path = e.composedPath ? e.composedPath() : [e.target];
    var hit = null;
    for (var i = 0; i < path.length; i++){
      if (path[i] === document.body) break;
      if (isCheckoutEl(path[i])){ hit = path[i]; break; }
    }
    if (!hit) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fetchCounts().then(function(c){
      if (cumple(c)){
        bypass = true;
        try { hit.click(); } finally { setTimeout(function(){ bypass = false; }, 0); }
      } else {
        showMsg(c);
      }
    });
  }, true);

  document.addEventListener('change', function(){ refreshSoon(600); }, true);
  document.addEventListener('submit', function(){ refreshSoon(800); }, true);

  function init(){ refreshPill(); renderTabla(); }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setInterval(refreshPill, 6000);
})();